import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { debounce } from 'lodash';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import ClickOutside from '@bit/knotchinc.web-react-components.click-outside';
import Box from '@bit/knotchinc.web-react-components.box';
import {
  StyledSearchInput,
  SearchContainer,
  SearchSuggestionContainer,
  EntityContainer,
  SelectedKeyword,
  SelectedDeleteButton,
  InputLabel,
  Keyword } from './styled';

const SearchKeywordSuggestion = ({ data, onClick, selectedKeywords }) => {
  const selected = selectedKeywords.find((keyword) => keyword === data.value.toLowerCase());
  return (
    !selected && (
      <EntityContainer key={data.value} onClick={() => onClick(data.value)}>
        <Keyword>{data.value}</Keyword>
      </EntityContainer>
    )
  );
};

class SearchKeywordInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
    };

    this.debouncedSearch = debounce(val => this.props.search(val), 500);
    this.searchRef = React.createRef();
  }

  search(val) {
    if (!val) {
      this.props.reset();
    }
    this.setState({ searchQuery: val }, () => this.debouncedSearch(val));
  }

  addKeyword(keyword) {
    this.setState({ searchQuery: '' });
    this.props.reset();
    this.props.onUpdate([...this.props.selectedKeywords, keyword]);
  }

  removeKeyword(keyword) {
    const { selectedKeywords, onUpdate } = this.props;
    onUpdate(selectedKeywords.filter(selectedKeyword => selectedKeyword !== keyword));
  }

  render() {
    const { keywordsList, selectedKeywords, label, fetch, filterAction } = this.props;
    const { searchQuery } = this.state;
    let container = null;

    if (this._scrollContainerRef) {
      container = this._scrollContainerRef._container;
    }

    return (<Box mb="20px">
      <SearchContainer onClick={() => this.searchRef.current.focus()}>
        {selectedKeywords.map(keyword =>
          <SelectedKeyword key={`keyword_selected_${keyword}`}>
            <Keyword>{keyword}</Keyword>
            <SelectedDeleteButton onClick={() => this.removeKeyword(keyword)}>×</SelectedDeleteButton>
          </SelectedKeyword>)
        }
        <Box display="inline-block" position="relative" pl="10px">
          <StyledSearchInput
            ref={this.searchRef}
            placeholder="Add more..."
            value={this.state.searchQuery}
            onChange={e => this.search(e.target.value)}
          />
          {searchQuery &&
          <ClickOutside close={() => this.search('')}>
            <SearchSuggestionContainer>
              <PerfectScrollbar ref={el => { this._scrollContainerRef = el; }}>
                <ListSync
                  fetch={fetch}
                  listStore={keywordsList}
                  actionType={filterAction}
                  loadOnScroll
                  container={container}
                >
                  <SearchKeywordSuggestion selectedKeywords={selectedKeywords} onClick={keyword => this.addKeyword(keyword)} />
                </ListSync>
              </PerfectScrollbar>
            </SearchSuggestionContainer>
            </ClickOutside>
          }
        </Box>
      </SearchContainer>
      <InputLabel>{label}</InputLabel>
    </Box>);
  }
}

SearchKeywordInput.defaultProps = {
  selectedKeywords: [],
};

export default SearchKeywordInput;
